import { render, staticRenderFns } from "./SavedLinks.vue?vue&type=template&id=6557f76d&scoped=true&"
import script from "./SavedLinks.vue?vue&type=script&lang=js&"
export * from "./SavedLinks.vue?vue&type=script&lang=js&"
import style0 from "./SavedLinks.vue?vue&type=style&index=0&id=6557f76d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6557f76d",
  null
  
)

export default component.exports